const statusMap = {
  OCCUPIED: 'Occupied',
  OCCUPIED_STAYOVER: 'Occupied(Stayover)',
  INSPECTED: 'Room Inspected',
  PROBLEM_FOUND: 'Problem Found',
  CLEAN: 'Room Clean',     
  OUT_OF_ORDER: 'Out of Service',
  DIRTY: 'Room Dirty',
  undefined: '',
};

export default statusMap;
